import { type ReactElement } from 'react';

import { Skeleton } from '@/components/ui/skeleton';

/** Placeholder rows while an inbox view's first page loads. */
export function TaskInboxSkeleton(): ReactElement {
  return (
    <div className="space-y-2" aria-hidden="true">
      {Array.from({ length: 6 }).map((_, i) => (
        <Skeleton key={i} className="h-12 w-full rounded-md" />
      ))}
    </div>
  );
}
